import { detail } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const GROUP_MENU = "groupMenu";
export function fetchIfNeeded() {
  return (dispatch) => {
    dispatch(detail.DetailActions.fetchIfNeeded(GROUP_MENU, 0, () => QSignDataApi.getMenuCounts()));
  };
}
export function invalidate() {
  return (dispatch) => {
    dispatch(detail.DetailActions.invalidate(GROUP_MENU, 0));
  };
}
